import {
  CREATING_GROUP_ORDER,
  CREATING_GROUP_ORDER_STEP,
  CURRENT_GROUP_ORDER_DETAILS,
  LOAD_GROUP_ORDER_PRODUCTS,
  SET_GROUP_ORDER_PRODUCTS,
  LOAD_GROUP_ORDER,
  SET_GROUP_ORDER_DETAILS,
  SET_GROUP_ORDER_TIERS,
  ADD_NEW_TIER_TO_GROUP_ORDER,
  SAVE_TEMP_GROUP_ORDER_TIER,
  UPDATE_GROUP_ORDER_TIER,
  REMOVE_GROUP_ORDER_TIER,
  RESTORE_TEMP_GROUP_ORDER_TIER,
  SET_REMOVE_MULTIPLE_TIER_ITEMS_STATUS,
  MARK_TEMPORALY_TIER_ITEM,
  UNMARK_TEMPORALY_TIER_ITEM,
  SET_UPDATING_TIER_ITEMS,
  SAVE_TIER_ITEMS_TO_REMOVE,
  UNSAVE_TIER_ITEMS_TO_REMOVE,
  RESET_TIER_ITEMS_TO_REMOVE,
  CLEAR_TEMPORALY_TIER_ITEMS,
  ADD_NEW_ITEM_TO_TIER,
  SAVE_TEMP_ITEM_TO_REMOVE,
  CLEAR_TEMP_ITEM_TO_REMOVE,
  RESTORE_TEMP_ITEM_TO_REMOVE,
  REMOVE_ITEM_FROM_TIER,
  UPDATING_GROUP_ORDER_PASSWORD,
  LOAD_GROUP_ORDERS_LIST,
  SET_GROUP_ORDERS_LIST,
  LOAD_GROUP_ORDER_ITEMS_ORDERED,
  SET_GROUP_ORDER_ITEMS_ORDERED,
  LOAD_GROUP_ORDER_RECIPIENTS_LIST,
  SET_GROUP_ORDER_RECIPIENT_LIST,
  SET_GROUP_ORDER_RECIPIENTS_EXPORT_LIST,
  LOAD_RECIPIENTS_GROUP_ORDER_SELECTED_ITEMS,
  SET_RECIPIENTS_SELECTED_ITEMS,
  IS_FINALIZING_GROUP_ORDER,
  ADD_RECIPIENT_TO_BE_SKIPPED_O_REMOVED_FROM_GO,
  REMOVE_RECIPIENT_FROM_GROUP_ORDER,
  CLEAN_RECIPIENTS_LIST_TO_REMOVE,
  LOAD_GROUP_ORDER_INFO,
  VALIDATING_GROUP_ORDER_RECIPIENT,
  SET_GROUP_ORDER_RECIPIENT,
  LOAD_GROUP_ORDER_TIERS_FOR_RECIPIENT,
  SET_SELECTABLE_GROUP_ORDER_TIERS,
  SET_CURRENT_ITEMS_SELECTED,
  ACTIVATE_ITEM,
  DEACTIVATE_ITEM,
  ADD_NEW_ITEM_TO_RECIPIENT_SELECTION,
  SET_REALID_TO_ITEM_RECIPIENT_SELECTION,
  REMOVE_TEMP_ITEM_RECIPIENT_SELECTION,
  REMOVE_ITEM_FROM_RECIPIENT_SELECTION,
  SAVE_TEMP_ITEM_TO_REMOVE_RECIPIENT_SELECTION,
  CLEAR_TEMP_ITEM_TO_REMOVE_RECIPIENT_SELECTION,
  RESTORE_TEMP_ITEM_TO_REMOVE_RECIPIENT_SELECTION,
  REMOVE_BUNDLE_ITEMS_RECIPIENT_SELECTION,
  SAVE_TEMP_BUNDLE_ITEMS_RECIPIENT_SELECTION,
  CLEAR_TEMP_BUNDLE_ITEMS_RECIPIENT_SELECTION,
  RESTORE_TEMP_BUNDLE_ITEMS_RECIPIENT_SELECTION,
  UPDATING_GROUP_ORDER_RECIPIENT,
  CONFIRM_RECIPIENT_GROUP_ORDER,
  IS_CONFIRMING_GROUP_ORDER,
  RESET_GROUP_ORDER_STATE,
  SET_CARD_MESSAGE,
  SET_SELECTED_TEMPLATE,
  HANDLE_VARIANT_SELECTION,
  SET_ORDERSTORE_PAGINATION_TOTAL_COUNT,
  SET_RECIPIENT_PAGINATION,
  SET_GROUP_ORDER_STATE,
  GETTING_SHIPPING_DETAILS,
  LOAD_ALLOW_LIST,
  SET_ALLOW_LIST,
  REMOVED_ALL_USERS_FROM_ALLOW_LIST,
  ALLOW_LIST_UPLOADED,
  VERIFICATION_EMAIL_STATUS,
  REDEMPTION_UUID,
  LOAD_ALLOW_LIST_ECOMMERCE,
  SET_ALLOW_LIST_ECOMMERCE,
  UPDATING_AUTO_FINALIZING
} from '@/state/mutationTypes'
import getGroupOrderStoreDefaultState from './groupOrderStoreDefaultState'

export default {
  [REDEMPTION_UUID](state, payload) {
    state.groupOrderDetails.uuid = payload
  },
  [VERIFICATION_EMAIL_STATUS](state, payload) {
    state.verificationEmailSent = payload
  },

  [ALLOW_LIST_UPLOADED](state, payload) {
    state.allowListUploaded = payload
  },

  [REMOVED_ALL_USERS_FROM_ALLOW_LIST](state, payload) {
    state.removeAllUsers = payload
  },

  [SET_ALLOW_LIST](state, payload) {
    state.allowList = payload
  },
  [SET_ALLOW_LIST_ECOMMERCE](state, payload) {
    state.allowListEcommerce = payload
  },

  [LOAD_ALLOW_LIST](state, payload) {
    state.loadAllowList = payload
  },
  [LOAD_ALLOW_LIST_ECOMMERCE](state, payload) {
    state.loadAllowListEcommerce = payload
  },
  [HANDLE_VARIANT_SELECTION](state, payload) {
    state.variantSelection = payload
  },

  [SET_CARD_MESSAGE](state, cardMessage) {
    state.groupOrderDetails.cardMessage = cardMessage
  },

  [SET_SELECTED_TEMPLATE](state, payload) {
    state.selectedTemplateId = payload
  },

  [CREATING_GROUP_ORDER](state, payload) {
    state.creatingGroupOrder = payload
  },
  [CURRENT_GROUP_ORDER_DETAILS](state, payload) {
    state.currentGroupOrderDetails = payload
  },
  [CREATING_GROUP_ORDER_STEP](state, payload) {
    state.creatingGroupOrderStep = payload
  },
  [LOAD_GROUP_ORDER_PRODUCTS](state, payload) {
    state.loadProducts = payload
  },
  [SET_GROUP_ORDER_PRODUCTS](state, payload) {
    state.groupOrderProducts = payload
  },
  [LOAD_GROUP_ORDER](state, payload) {
    state.loadGroupOrder = payload
  },
  [SET_GROUP_ORDER_DETAILS](state, payload) {
    state.groupOrderDetails = payload
  },
  [SET_GROUP_ORDER_TIERS](state, payload) {
    state.groupOrderTiers = [...payload]
  },
  [ADD_NEW_TIER_TO_GROUP_ORDER](state, payload) {
    state.groupOrderTiers = [...state.groupOrderTiers, payload]
  },
  [SAVE_TEMP_GROUP_ORDER_TIER](state, payload) {
    let groupTiers = state.groupOrderTiers
    let index = groupTiers.findIndex(tier => tier.id == payload.id)
    state.tempGroupOrderTier = { ...groupTiers[index] }
  },
  [UPDATE_GROUP_ORDER_TIER](state, payload) {
    let groupTiers = state.groupOrderTiers
    let index = groupTiers.findIndex(tier => tier.id === payload.id)

    groupTiers[index].tierQuantityLimit = `${payload.tierQuantityLimit}`
    groupTiers[index].selectionType = payload.selectionType
    groupTiers[index].name = payload.name

    state.groupOrderTiers = groupTiers
  },
  [REMOVE_GROUP_ORDER_TIER](state, payload) {
    let groupTiers = state.groupOrderTiers
    groupTiers = groupTiers.filter(tier => tier.id !== payload)
    state.groupOrderTiers = groupTiers
  },
  [RESTORE_TEMP_GROUP_ORDER_TIER](state, payload) {
    let groupTiers = state.groupOrderTiers
    let tempGroupOrderTier = state.tempGroupOrderTier
    let index = groupTiers.findIndex(tier => tier.id === payload.id)
    groupTiers[index].tierQuantityLimit = tempGroupOrderTier.tierQuantityLimit
    state.groupTiers = [...groupTiers]
  },
  [MARK_TEMPORALY_TIER_ITEM](state, payload) {
    let temporalSelectedItems = state.temporalSelectedItems
    let index = temporalSelectedItems.findIndex(
      item => item.productId === (payload.id ? payload.id : payload)
    )

    if (index >= 0) {
      temporalSelectedItems = temporalSelectedItems.filter(
        item => item.productId !== (payload.id ? payload.id : payload)
      )
    } else {
      temporalSelectedItems = [...temporalSelectedItems, { ...payload }]
    }
    state.temporalSelectedItems = [...temporalSelectedItems]
  },
  [UNMARK_TEMPORALY_TIER_ITEM](state, payload) {
    let temporalSelectedItems = state.temporalSelectedItems
    temporalSelectedItems = temporalSelectedItems.filter(
      tier => tier.productId !== payload
    )

    state.temporalSelectedItems = [...temporalSelectedItems]
  },
  [CLEAR_TEMPORALY_TIER_ITEMS](state) {
    state.temporalSelectedItems = []
  },
  [SET_UPDATING_TIER_ITEMS](state, payload) {
    state.updatingGroupTierItems = payload
  },
  [ADD_NEW_ITEM_TO_TIER](state, payload) {
    let groupOrderTiers = state.groupOrderTiers
    let temporalSelectedItems = state.temporalSelectedItems

    let tierIndex = groupOrderTiers.findIndex(
      tier => tier.id === payload.tierId
    )

    groupOrderTiers[tierIndex].tierItems = [
      ...groupOrderTiers[tierIndex].tierItems,
      { ...payload.newTierItem }
    ]

    // remove temp item
    temporalSelectedItems = temporalSelectedItems.filter(
      t => t !== payload.newTierItem.itemableId
    )

    state.groupOrderTiers = [...groupOrderTiers]
    state.temporalSelectedItems = [...temporalSelectedItems]
  },
  [SAVE_TEMP_ITEM_TO_REMOVE](state, payload) {
    let groupOrderTiers = state.groupOrderTiers
    let tierIndex = groupOrderTiers.findIndex(
      tier => tier.id === payload.tierId
    )
    let item = groupOrderTiers[tierIndex].tierItems.find(
      item => item.itemId === payload.itemId
    )
    state.tempItemToRemove = { ...item }
  },
  [SAVE_TIER_ITEMS_TO_REMOVE](state, payload) {
    state.selectedTierItemsToRemove = [
      ...state.selectedTierItemsToRemove,
      payload
    ]
  },
  [UNSAVE_TIER_ITEMS_TO_REMOVE](state, payload) {
    let selectedTierItemsToRemove = state.selectedTierItemsToRemove
    selectedTierItemsToRemove = selectedTierItemsToRemove.filter(
      tierItem => tierItem.itemId !== payload
    )
    state.selectedTierItemsToRemove = [...selectedTierItemsToRemove]
  },
  [SET_REMOVE_MULTIPLE_TIER_ITEMS_STATUS](state, payload) {
    state.removeMultipleTierItemsStatus = payload
  },
  [RESET_TIER_ITEMS_TO_REMOVE](state) {
    state.selectedTierItemsToRemove = []
  },
  [CLEAR_TEMP_ITEM_TO_REMOVE](state) {
    state.tempItemToRemove = {}
  },
  [RESTORE_TEMP_ITEM_TO_REMOVE](state, payload) {
    let groupOrderTiers = state.groupOrderTiers
    let tempItemToRemove = state.tempItemToRemove

    let tierIndex = groupOrderTiers.findIndex(
      tier => tier.id === payload.tierId
    )
    groupOrderTiers[tierIndex].tierItems.push(tempItemToRemove)
    state.groupOrderTiers = [...groupOrderTiers]
  },
  [REMOVE_ITEM_FROM_TIER](state, payload) {
    let groupOrderTiers = state.groupOrderTiers
    let tierIndex = groupOrderTiers.findIndex(
      tier => tier.id === payload.tierId
    )
    let tierItems = groupOrderTiers[tierIndex].tierItems
    tierItems = tierItems.filter(item => item.itemId !== payload.itemId)
    groupOrderTiers[tierIndex].tierItems = [...tierItems]
    state.groupOrderTiers = [...groupOrderTiers]
  },
  [UPDATING_GROUP_ORDER_PASSWORD](state, payload) {
    state.updatingGroupOrderPassword = payload
  },
  [LOAD_GROUP_ORDERS_LIST](state, payload) {
    state.loadGroupOrdersList = payload
  },
  [SET_GROUP_ORDERS_LIST](state, payload) {
    state.groupOrdersList = [...payload]
  },
  [LOAD_GROUP_ORDER_ITEMS_ORDERED](state, payload) {
    state.loadGroupOrderItemsOrdered = payload
  },
  [SET_GROUP_ORDER_ITEMS_ORDERED](state, payload) {
    state.groupOrderItemsOrdered = [...payload]
  },
  [LOAD_GROUP_ORDER_RECIPIENTS_LIST](state, payload) {
    state.loadGroupOrderRecipientsList = payload
  },
  [SET_GROUP_ORDER_RECIPIENT_LIST](state, payload) {
    state.groupOrderRecipientsList = [...payload]
  },
  [SET_GROUP_ORDER_RECIPIENTS_EXPORT_LIST](state, payload) {
    state.groupOrderRecipientsListExport = [...payload]
  },
  [LOAD_RECIPIENTS_GROUP_ORDER_SELECTED_ITEMS](state, payload) {
    state.loadRecipientGroupOrderSelectedItems = payload
  },
  [SET_RECIPIENTS_SELECTED_ITEMS](state, payload) {
    state.recipientsGroupOrderSelectedItems = [...payload]
  },
  [IS_FINALIZING_GROUP_ORDER](state, payload) {
    state.finalizingGroupOrder = payload
  },
  [ADD_RECIPIENT_TO_BE_SKIPPED_O_REMOVED_FROM_GO](state, payload) {
    let { recipientsToSkipOrRemove } = state
    let index = recipientsToSkipOrRemove.findIndex(user => user.id === payload)

    if (index >= 0) {
      state.recipientsToSkipOrRemove = recipientsToSkipOrRemove.filter(
        user => user.id !== payload
      )
    } else {
      state.recipientsToSkipOrRemove = [
        ...recipientsToSkipOrRemove,
        { id: payload }
      ]
    }
  },
  [REMOVE_RECIPIENT_FROM_GROUP_ORDER](state, payload) {
    let groupOrderRecipientsList = state.groupOrderRecipientsList.filter(
      recipient => parseInt(recipient.id) !== payload
    )
    state.groupOrderRecipientsList = [...groupOrderRecipientsList]
  },
  [CLEAN_RECIPIENTS_LIST_TO_REMOVE](state) {
    state.recipientsToSkipOrRemove = []
  },
  [LOAD_GROUP_ORDER_INFO](state, payload) {
    state.loadGroupOrderPublicInfo = payload
  },
  [VALIDATING_GROUP_ORDER_RECIPIENT](state, payload) {
    state.validatingRecipient = payload
  },
  [SET_GROUP_ORDER_RECIPIENT](state, payload) {
    state.recipient = { ...payload }
  },
  [LOAD_GROUP_ORDER_TIERS_FOR_RECIPIENT](state, payload) {
    state.loadGroupOrderTiersForRecipient = payload
  },
  [SET_SELECTABLE_GROUP_ORDER_TIERS](state, payload) {
    state.selectableTiers = [...payload]
  },
  [SET_CURRENT_ITEMS_SELECTED](state, payload) {
    state.selectedVariants = [...payload]
  },
  [ACTIVATE_ITEM](state, payload) {
    let activeItemsPerTier = state.activeItemsPerTier
    activeItemsPerTier = [...activeItemsPerTier, payload]
    state.activeItemsPerTier = [...activeItemsPerTier]
  },
  [DEACTIVATE_ITEM](state, payload) {
    let activeItemsPerTier = state.activeItemsPerTier
    let tierItems = activeItemsPerTier.filter(
      item => parseInt(item.tierId) === parseInt(payload.tierId)
    )
    let tierOtherTiers = activeItemsPerTier.filter(
      item => parseInt(item.tierId) !== parseInt(payload.tierId)
    )

    tierItems = tierItems.filter(item => item.id !== payload.id)
    activeItemsPerTier = [...tierItems, ...tierOtherTiers]
    state.activeItemsPerTier = [...activeItemsPerTier]
  },
  [ADD_NEW_ITEM_TO_RECIPIENT_SELECTION](state, payload) {
    let selectedVariants = state.selectedVariants
    selectedVariants = [...selectedVariants, payload]
    state.selectedVariants = [...selectedVariants]
  },
  [SET_REALID_TO_ITEM_RECIPIENT_SELECTION](state, payload) {
    let selectedVariants = state.selectedVariants
    let { realId, randomId } = payload

    let indexNewItem = selectedVariants.findIndex(
      variant => variant.id === randomId
    )
    if (indexNewItem >= 0) {
      selectedVariants[indexNewItem].id = realId
      state.selectedVariants = [...selectedVariants]
    }
  },
  [REMOVE_TEMP_ITEM_RECIPIENT_SELECTION](state, payload) {
    let selectedVariants = state.selectedVariants
    selectedVariants = selectedVariants.filter(
      variant => variant.id !== payload
    )
    state.selectedVariants = [...selectedVariants]
  },
  [REMOVE_ITEM_FROM_RECIPIENT_SELECTION](state, payload) {
    let selectedVariants = state.selectedVariants
    selectedVariants = selectedVariants.filter(
      variant => parseInt(variant.id) !== parseInt(payload)
    )
    state.selectedVariants = [...selectedVariants]
  },
  [SAVE_TEMP_ITEM_TO_REMOVE_RECIPIENT_SELECTION](state, payload) {
    let selectedVariants = state.selectedVariants
    let variantIndex = selectedVariants.findIndex(
      variant => parseInt(variant.id) === parseInt(payload)
    )
    state.tempItemToRemoveRecipient = { ...selectedVariants[variantIndex] }
  },
  [CLEAR_TEMP_ITEM_TO_REMOVE_RECIPIENT_SELECTION](state) {
    state.tempItemToRemoveRecipient = {}
  },
  [RESTORE_TEMP_ITEM_TO_REMOVE_RECIPIENT_SELECTION](state) {
    let selectedVariants = state.selectedVariants
    let tempItemToRemoveRecipient = state.tempItemToRemoveRecipient
    selectedVariants.push(tempItemToRemoveRecipient)
    state.selectedVariants = [...selectedVariants]
  },
  [REMOVE_BUNDLE_ITEMS_RECIPIENT_SELECTION](state, payload) {
    let selectedVariants = state.selectedVariants
    // get items related to different tierId
    let exclededItems = selectedVariants.filter(
      variant => parseInt(variant.tierId) !== parseInt(payload.tierId)
    )

    let relatedItems = selectedVariants.filter(
      variant => parseInt(variant.tierId) === parseInt(payload.tierId)
    )

    relatedItems = relatedItems.filter(
      item => parseInt(item.bundleId) !== parseInt(payload.bundleId)
    )

    state.selectedVariants = [...exclededItems, ...relatedItems]
  },
  [SAVE_TEMP_BUNDLE_ITEMS_RECIPIENT_SELECTION](state, payload) {
    let selectedVariants = state.selectedVariants
    let tempItemsToSave = selectedVariants.filter(
      variant =>
        parseInt(variant.bundleId) === parseInt(payload.bundleId) &&
        parseInt(variant.tierId) === parseInt(payload.tierId)
    )
    state.tempBundleItemsToRemove = [...tempItemsToSave]
  },
  [CLEAR_TEMP_BUNDLE_ITEMS_RECIPIENT_SELECTION](state) {
    state.tempBundleItemsToRemove = []
  },
  [RESTORE_TEMP_BUNDLE_ITEMS_RECIPIENT_SELECTION](state) {
    let selectedVariants = state.selectedVariants
    let tempBundleItemsToRemove = state.tempBundleItemsToRemove
    state.selectedVariants = [...selectedVariants, ...tempBundleItemsToRemove]
  },
  [UPDATING_GROUP_ORDER_RECIPIENT](state, payload) {
    state.updatingRecipientInfo = payload
  },
  [CONFIRM_RECIPIENT_GROUP_ORDER](state) {
    state.confirmWithSuccess = true
  },
  [IS_CONFIRMING_GROUP_ORDER](state, payload) {
    state.isConfirming = payload
  },
  [RESET_GROUP_ORDER_STATE](state) {
    Object.assign(state, getGroupOrderStoreDefaultState())
  },
  [SET_ORDERSTORE_PAGINATION_TOTAL_COUNT](state, payload) {
    state.paginationTotalCount = payload
  },
  [SET_RECIPIENT_PAGINATION](state, payload) {
    state.recipientTotal = payload
  },
  [SET_GROUP_ORDER_STATE](state, payload) {
    state.groupOrderDetails.state = payload
  },
  [GETTING_SHIPPING_DETAILS](state, payload) {
    state.shippingLoading = payload
  },
  [UPDATING_AUTO_FINALIZING](state, payload) {
    state.updatingAutoFinalizing = payload
  }
}
